import { lazy } from "react";
// Module I — New Member Onboarding (Onboarding Journey)
// Pipeline de nuevos miembros: welcome call → records → first appointment → HRA.

const MemberOnboardingPage = lazy(() => import("./pages/MemberOnboardingPage"));
// Export routes for AppRouter
export const memberOnboardingRoutes = [
  {
    path: "/member-onboarding",
    element: <MemberOnboardingPage />,
  },
];

// Export components for external use
